export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-speed-limit-1200-882b9b041fc03d21af89d4f9c24a6bed.png";